import { makeServiceCall } from 'redux-core/serviceHelpers';

export const getTemplateFileUrlCall = makeServiceCall('uploads', 'get-tracks-import-template-download-url');

export const getTracksImportUploadAccessCall = async ({ kind, contentType }) => {
    const call = makeServiceCall('uploads', 'upload-tracks-import-file');
    return call({ kind, contentType });
};

export const validateImportFileCall = async ({ s3FileKey, userId, productionId, cueContainerId }) => {
    const call = makeServiceCall('tracks-import', 'validate', 'clear');
    return call({ s3FileKey, userId, productionId, cueContainerId });
};

export const processImportFileCall = async ({ jobId, divisionId }) => {
    const call = makeServiceCall('tracks-import', 'process', 'clear');
    return call({ jobId, divisionId });
};

export const checkImportFileCall = async ({ productionId }) => {
    const call = makeServiceCall('tracks-import', 'check', 'clear');
    return call({ productionId });
};
